module.exports = __webpack_public_path__ + "img/main6.aca7de70.png";